import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/runScenario';
import { fetchRequest as refreshScenarios } from '../../actions/discovery/scenarios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId, spec } = action?.payload || {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/scenarios`,
      spec,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
    // Refresh the saved list so the new scenario appears immediately.
    yield put(refreshScenarios({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
